document.addEventListener('facetwp-loaded', function () {
    document.querySelectorAll('.facetwp-input-wrap').forEach(function (wrap) {
        if (!wrap.querySelector('.facetwp-search-submit')) {
            var btn = document.createElement('button');
            btn.className = 'facetwp-search-submit';
            btn.setAttribute('onclick', 'FWP.refresh()');
            btn.textContent = 'Zoeken';
            wrap.querySelector('.facetwp-search').after(btn);
        }
    });
});

(function () {
    const facetName = 'news_search';

    document.addEventListener('facetwp-loaded', function () {
        document.querySelectorAll(`[data-name="${facetName}"] .facetwp-search`).forEach(function (searchbox) {
            const wrap = searchbox.closest('.facetwp-input-wrap');

            if (!wrap) {
                return;
            }

            let clearIcon = wrap.querySelector('i.clear');

            if (!clearIcon) {
                clearIcon = document.createElement('i');
                clearIcon.className = 'clear';
                clearIcon.title = 'Clear Search';
                clearIcon.setAttribute('role', 'button');
                clearIcon.setAttribute('tabindex', '0');
                clearIcon.setAttribute('aria-label', 'Clear Search');
                searchbox.after(clearIcon);
            }

            const toggleClearIcon = function () {
                clearIcon.hidden = searchbox.value.trim() === '';
            };

            if (!searchbox.dataset.clearSearchInitialized) {
                searchbox.dataset.clearSearchInitialized = 'true';

                searchbox.addEventListener('input', function () {
                    if (FWP.settings[facetName]['auto_refresh'] === 'yes') {
                        searchbox.classList.add('loading');
                    }

                    toggleClearIcon();
                });

                const clearSearch = function () {
                    if (searchbox.classList.contains('loading') || wrap.querySelector('.f-loading')) {
                        return;
                    }

                    searchbox.value = '';
                    toggleClearIcon();
                    searchbox.focus();

                    if (FWP.facets[facetName].length) {
                        FWP.autoload();
                    }
                };

                clearIcon.addEventListener('click', clearSearch);
                clearIcon.addEventListener('keydown', function (event) {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        clearSearch();
                    }
                });
            }

            searchbox.classList.remove('loading');
            toggleClearIcon();
        });
    });
})();
